import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CommonModule } from '@angular/common';
import { TabsHomePage } from './tabs-home';
import { ComponentsModule } from '../../components/components.module';
import { ActivityPageModule } from '../activity/activity.module' // preload the page to speed up during biometrics login
import { WalletHomePageModule } from '../wallet-home/wallet-home.module' // preload the page to speed up during biometrics login
import { WalletNotActivePageModule } from '../wallet-not-active/wallet-not-active.module' // preload the page to speed up during biometrics login

@NgModule({
  declarations: [
    TabsHomePage,
  ],
  imports: [
    IonicPageModule.forChild(TabsHomePage),
    CommonModule,
    ComponentsModule,
    ActivityPageModule,
    WalletHomePageModule,
    WalletNotActivePageModule,

  ],
})
export class TabsHomePageModule { }



// WEBPACK FOOTER //
// ./src/pages/tabs-home/tabs-home.module.ts